export default "__VITE_ASSET__ba3f11f5__"